import { applyMiddleware, createStore } from 'redux';
import { rootReducer } from './reducers';
import { createLogger } from 'redux-logger';

const store = createStore(rootReducer);

export { store };
